import { MijnRoute } from '../mijn-navigatie.model';

export const ZAKELIJK_DIGIPAS_VERVANGEN: MijnRoute = {
    path: 'zakelijk-digipas-vervangen',
    navigationEvent: 'toZakelijkDigipasVervangen',
    regex: /^\/zakelijk-digipas-vervangen$/,
    webcomponent: 'mijn-zakelijk-digipas-vervangen-webcomponent'
};
